import { render } from "./ArticlesOrder.vue?vue&type=template&id=2cfc1d16&ts=true"
import script from "./ArticlesOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesOrder.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cfc1d16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cfc1d16', __exports__)) {
    api.reload('2cfc1d16', __exports__)
  }
  
  module.hot.accept("./ArticlesOrder.vue?vue&type=template&id=2cfc1d16&ts=true", () => {
    api.rerender('2cfc1d16', render)
  })

}


export default __exports__